import React from 'react';
import styled from 'styled-components';
import { Input, Button } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "url-inputcomponent__Container",
  componentId: "sc-g9rxlc-0"
})(["display:flex;flex-direction:column;gap:8px;"]);
var Label = styled.div.withConfig({
  displayName: "url-inputcomponent__Label",
  componentId: "sc-g9rxlc-1"
})(["font-weight:600;font-size:14px;color:#1a2140;"]);
var InputWrapper = styled.div.withConfig({
  displayName: "url-inputcomponent__InputWrapper",
  componentId: "sc-g9rxlc-2"
})(["display:flex;gap:8px;"]);
var StyledInput = styled(Input).withConfig({
  displayName: "url-inputcomponent__StyledInput",
  componentId: "sc-g9rxlc-3"
})(["flex:1;height:44px;border-radius:8px;border:1.5px solid #e0e4ef;&:hover,&:focus{border-color:#5a6acf;}"]);
var AddButton = styled(Button).withConfig({
  displayName: "url-inputcomponent__AddButton",
  componentId: "sc-g9rxlc-4"
})(["height:44px;border-radius:8px;font-weight:600;background-color:#2563eb;border-color:#2563eb;&:hover{background-color:#1d4ed8;border-color:#1d4ed8;}"]);
var HelpText = styled.div.withConfig({
  displayName: "url-inputcomponent__HelpText",
  componentId: "sc-g9rxlc-5"
})(["font-size:12px;color:#8b95b0;"]);
export var UrlInput = function UrlInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onAdd = _ref.onAdd,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Label, {
      children: "Enter File URL"
    }), /*#__PURE__*/_jsxs(InputWrapper, {
      children: [/*#__PURE__*/_jsx(StyledInput, {
        placeholder: "https://example.com/document.pdf",
        value: value,
        onChange: onChange,
        onPressEnter: onAdd,
        disabled: disabled
      }), /*#__PURE__*/_jsx(AddButton, {
        type: "primary",
        onClick: onAdd,
        disabled: disabled || !value.trim(),
        children: "Add"
      })]
    }), /*#__PURE__*/_jsx(HelpText, {
      children: "Only document files are supported (e.g., .doc, .docx, .pdf)."
    })]
  });
};